import { render, staticRenderFns } from "./mentor-chats-notifications-bell-polling.vue?vue&type=template&id=3b1e7876"
import script from "./mentor-chats-notifications-bell-polling.vue?vue&type=script&lang=js"
export * from "./mentor-chats-notifications-bell-polling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports